module.exports = __webpack_public_path__ + "img/icon1.7c6f67b8.png";